<script setup>
  import { getEmployerCover, getEmployerLogo } from '~/utils/employer'
  import { getQuery, getJobUrl } from '~/utils/url'

  const { job } = defineProps({
    job: { required: true, type: Object },
    isCareerSite: { default: false, type: Boolean }
  })

  const route = useRoute()

  const logo = computed(() => getEmployerLogo(job.employer))
  const cover = computed(() => getEmployerCover(job.employer))
</script>

<template>
  <NuxtLink
    class="group flex flex-col rounded-xl drop-shadow-md duration-300 hover:drop-shadow-xl md:flex-row"
    :class="{ 'md:flex-row': !job.imported }"
    :to="`${getJobUrl(job, isCareerSite)}${getQuery(route.query)}`"
  >
    <NuxtImg
      class="rounded-t-xl object-cover md:h-[200px] md:w-[270px] md:rounded-xl"
      v-if="!job.imported"
      :src="cover?.url ? useStrapiMedia(cover.url) : '/images/no-image.webp'"
      :alt="job.title"
    />
    <div
      :class="[
        'relative w-full rounded-b-xl bg-white p-4 pl-6 duration-300 md:my-4',
        job.imported ? 'md:rounded-l-xl md:rounded-r-xl md:pl-16' : 'md:rounded-l-none md:rounded-r-xl'
      ]"
    >
      <div class="flex flex-1 items-center space-x-2 pr-16">
        <NuxtImg
          class="size-8 rounded-full bg-zinc-300 bg-cover bg-center"
          :src="logo?.url ? useStrapiMedia(logo.url) : '/images/no-image.webp'"
          :alt="job.employer?.name"
        />
        <div class="line-clamp-1" v-text="job.employer?.name" />
      </div>
      <FavoriteToggle
        custom-class="absolute bottom-6 right-6 scale-150 md:right-4 md:top-6 md:scale-100 md:hover:scale-105"
        :job="job"
        :route="route.fullPath"
        size="lg"
      />
      <div class="line-clamp-2 pt-2 font-special text-xl font-bold md:line-clamp-1 md:text-lg" v-text="job.title" />
      <div class="flex flex-col justify-between space-y-2 pt-4 md:flex-row md:space-y-0">
        <div class="flex items-center space-x-3">
          <div class="flex items-center space-x-1.5" v-if="job.locations?.length && job.locations[0].city">
            <Icon name="location-dot" />
            <span>{{ job.locations[0].city }}</span>
          </div>
          <div class="rounded-lg bg-zinc-200 p-1" v-if="job.type !== 'public'" v-text="convertJobType(job.type)" />
        </div>
        <p class="md:ml-auto">{{ $dayjs(job.validatedAt).fromNow() }}</p>
      </div>
    </div>
  </NuxtLink>
</template>
